import { Bot, Plus } from "lucide-react";
import BrandPane from "./BrandPane";
import NavigationPane from "./NavigationPane";
import ProjectsTable from "./ProjectsTable";
const ProjectsPage = () => {
    return (
        <div className="flex h-screen bg-gray-50">
            {/* Brand Pane */}
            <BrandPane />

            {/* Navigation Pane */}
            <NavigationPane />

            {/* Main Content */}
            <div className="flex-1 overflow-auto p-8">
                {/* Header */}
                <div className="p-6 flex justify-end bg-white">
                    <img
                        src="/synthio_logo_with_text.png"
                        alt="SynthioLabs Logo"
                        className="h-8 w-auto"
                    />
                </div>

                {/* New Project Banner */}
                <div className="bg-white rounded-lg shadow-sm p-12 mb-8 text-center">
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                            <Bot size={32} className="text-blue-600" />
                        </div>
                    </div>
                    <h2 className="text-xl font-semibold mb-2">
                        Create a new Project
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Your blank canvas awaits! Get your content reviewed from
                        our state of the art AI MLR expert personas custom built
                        for your brand
                    </p>
                    <button className="inline-flex items-center px-4 py-2 bg-[#5a55f4] text-white rounded-md hover:bg-blue-700 transition-colors">
                        <Plus size={16} className="mr-2" />
                        Create Project
                    </button>
                </div>

                {/* Projects Table */}
                {/* Recent Activity Header */}
                <div className="flex justify-between items-center mb-4 mt-16">
                    <h2 className="text-xl font-semibold text-gray-800">
                        My Projects
                    </h2>
                </div>

                {/* Activity Table */}
                <ProjectsTable />
            </div>
        </div>
    );
};

export default ProjectsPage;
